module.exports = __webpack_public_path__ + "static/media/gallery_07_thumb.407f3a25.jpg";